import React from "react";
import moment from "moment";
import { Table, Td, Tr, TableHeaderRow } from "../../SetiTable.styled";
import { BG_COLOR, GameStatusIcon, getGameStatus } from "../ReportElements";
import { FooterRows } from "../mlb/FooterRows";
import { AggregateHealthRow } from "../mlb/AggregateHealthRow";
import { DataColumns } from "../mlb/DataColumns";
import {
  dataColumnGroups,
  GroupHeaderCell,
  HeaderCell,
} from "../mlb/HeaderRows";
import NGEQualityLink from "../../elements/NGEQualityLink";

const NGE_INFO_COLUMN_COUNT = 4; // Event Name, Venue, Event ID, Event Time
const NGE_INFO_COLUMN_COUNT_WITH_ACTIONS = 5;

function NGEInfoHeaderCells(canCreateIncident) {
  const cells = [
    { label: "Event Name", textAlignment: "left" },
    { label: "Venue", textAlignment: "left" },
    { label: "Event ID", textAlignment: "right" },
    { label: "Event Time", textAlignment: "right" },
  ];
  if (canCreateIncident) {
    cells.push({ label: "Actions" });
  }
  return cells;
}

function NGEHeaderRows({ isPreHawkeye, canCreateIncident, groupsToShow }) {
  const infoGroup = {
    groupLabel: "",
    style: { background: "#ffffff", border: 0 },
    headerCells: NGEInfoHeaderCells(canCreateIncident),
  };
  const groups = [infoGroup, ...dataColumnGroups(isPreHawkeye, groupsToShow)];

  return (
    <>
      <TableHeaderRow>
        {groups.map((group, idx) => GroupHeaderCell(group, idx))}
      </TableHeaderRow>
      <TableHeaderRow>
        {groups.map((group, groupIdx) =>
          group.headerCells.map((column, columnIdx) =>
            HeaderCell(column, `${groupIdx}-${columnIdx}`),
          ),
        )}
      </TableHeaderRow>
    </>
  );
}

class NGETrackingAccuracyReportTable extends React.Component {
  render() {
    const {
      data = { date: "", records: [] },
      gameStatuses,
      canCreateIncident,
      groupsToShow,
      dropDownContainer: DropDownContainer,
    } = this.props;
    const year = (data.date || "").split("-")[0] || new Date().getFullYear();
    const isPreHawkeye = year < 2020;
    const infoColCount = canCreateIncident
      ? NGE_INFO_COLUMN_COUNT_WITH_ACTIONS
      : NGE_INFO_COLUMN_COUNT;

    const bodyRows = (data.records || []).map((record) => {
      const { game, tracking } = record;

      return (
        <Tr key={game.gamePk}>
          <Td textAlignment="left" noWrap>
            <div className="flex-between">
              <NGEQualityLink game={game} />
              <GameStatusIcon>
                {getGameStatus(game.gamePk, gameStatuses)}
              </GameStatusIcon>
            </div>
          </Td>
          <Td textAlignment="left">{game.venue?.name || ""}</Td>
          <Td textAlignment="right">{game.gamePk}</Td>
          <Td textAlignment="right" noWrap>
            {moment(game.gameDate).local().format("LT")}
          </Td>
          {canCreateIncident ? (
            <Td noPadding bgcolor={BG_COLOR}>
              <DropDownContainer game={game} />
            </Td>
          ) : null}
          <DataColumns
            game={game}
            tracking={tracking}
            isPreHawkeye={isPreHawkeye}
            groupsToShow={groupsToShow}
            showPitchesAsCount
            showBipAsCount
            showSwingsAsCount
          />
        </Tr>
      );
    });

    return (
      <Table>
        <colgroup>
          <col width="12%" />
          <col />
          <col />
          <col />
          {canCreateIncident && <col width="8%" />}
        </colgroup>
        <thead>
          <NGEHeaderRows
            isPreHawkeye={isPreHawkeye}
            canCreateIncident={canCreateIncident}
            groupsToShow={groupsToShow}
          />
        </thead>
        <tbody>
          {bodyRows}
          <AggregateHealthRow
            data={data}
            isPreHawkeye={isPreHawkeye}
            canCreateIncident={canCreateIncident}
            groupsToShow={groupsToShow}
            infoColumnCount={infoColCount}
            showPitchesAsCount
            showBipAsCount
            showSwingsAsCount
          />
        </tbody>
        <tfoot>
          <FooterRows
            isPreHawkeye={isPreHawkeye}
            year={year}
            canCreateIncident={canCreateIncident}
            groupsToShow={groupsToShow}
            infoColumnCount={infoColCount}
            showPitchesAsCount
            showBipAsCount
            showSwingsAsCount
          />
        </tfoot>
      </Table>
    );
  }
}

NGETrackingAccuracyReportTable.defaultProps = {
  data: { records: [] },
};

export default NGETrackingAccuracyReportTable;
